import { useIntl } from 'react-intl';

export interface TypedMessages {
  [key: string]: string;
}

export const useTypedIntl = () => {
  const { messages, ...rest } = useIntl();

  // Type assertion to ensure messages are always strings
  const typedMessages: TypedMessages = messages as TypedMessages;

  return {
    messages: typedMessages,
    ...rest,
  };
};
